export default "__VITE_ASSET__CNxXOSLo__"